export const POS_MIN_TIME_DELAY = 1;

export const POS_MAX_STARTING_CASH = 999.99; // in $

export const DEFAULT_GRADE_ID = '00';

export const POS_MAX_ITEM_QUANTITY = 999;

export const POS_MAX_BULK_SERVE_QUANTITY = 999;

export const POS_MAX_AMOUNT_PAID_SIZE = [5, 2];

export const POS_MAX_CHECK_NUMBER_LENGTH = 6;

export const POS_ALACARTE_NOLIMIT = 'nolimit';



// WEBPACK FOOTER //
// ./src/common/Constants/pos.js